

export const dateSuffix = function (number) {
    var d = number % 10;
    return (~~ (number % 100 / 10) === 1) ? 'th' :
        (d === 1) ? 'st' :
        (d === 2) ? 'nd' :
        (d === 3) ? 'rd' : 'th';
}

export const days = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday'
];

export const daysShort = [
    'Mon',
    'Tue',
    'Wed',
    'Thu',
    'Fri',
    'Sat',
    'Sun'
];

export const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];

export const monthsShort = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec'
];

export function isNumeric(value) {
    const allowedTypes = ['string', 'number'];
    return allowedTypes.includes(typeof value) && value.toString() && ! isNaN(value)
}


export function parseKeyValuesToInt(object, keys) {
    for (let key of keys) {
        object[key] = parseInt(object[key]);
    }
    return object;
}

/**
 * Finds the largest number in an array
 * @param array
 * @return int
 */
export function getLargestNumber(array) {
    return Math.max.apply(0, array);
}

/**
 * Used to set default config setting if not set on the window object
 * @param {object} config
 * @param {object} defaults
 * @return {object} config
 */
export function setDefaultsIfNotSet(config, defaults) {
    for (let setting in defaults) {
        if (config[setting] == undefined) {
            config[setting] = defaults[setting];
            continue;
        }
        const isObject = (
            typeof config[setting] == 'object' &&
            ! Array.isArray(config[setting])
        );
        if (isObject) {
            config[setting] = setDefaultsIfNotSet(config[setting], defaults[setting]);
        }
    }

    return config;
}

/**
 * Re-orders days of week based on the index passed.
 *
 * @param days {string[]} Must always be Mon-Sun
 * @param index {number}
 * @return {string[]}
 */
export function orderDaysStartingWithIndex(days, index)
{
    return days.slice(index).concat(days.slice(0, index));
}


/**
 * Retrieves the value of a cookie by its name.
 * @param {string} name The name of the cookie to retrieve.
 * @returns {string|null} The value of the cookie, or null if not found.
 */
export function getCookie(name) {
    // Construct the name to search for, ensuring it matches the beginning of a cookie string
    // and includes the '=' sign. Also, encode it to handle special characters.
    const nameEQ = encodeURIComponent(name) + '=';

    // Split the document.cookie string into individual cookie parts
    const ca = document.cookie.split(';');

    // Loop through the array of cookie parts
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i].trim();

        // If this cookie part starts with the name we're looking for
        if (c.indexOf(nameEQ) === 0) {
            // Extract and decode the value part (after "name=")
            return decodeURIComponent(c.substring(nameEQ.length, c.length));
        }
    }

    return null;
}

export function toEasternArabicDigits(str) {
    const isArabic = document.documentElement?.lang === 'ar' || getCookie("chosen_locale") === 'ar';

    if (isArabic) {
        const easternArabicDigits = ['٠','١','٢','٣','٤','٥','٦','٧','٨','٩'];
        return String(str).replace(/\d/g, d => easternArabicDigits[d]);
    }
    return str;
};
